import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import styles from 'styles/pages/LoginAuthorized.module.less';
import { useHistory } from 'react-router-dom';
import { getAccessToken } from '../../store/requests/auth';
import { PAGE_URLS } from '../../helpers/endpoints';

const LoginAuthorized = () => {
  const history = useHistory();
  const searchString = useLocation().search;
  const code = new URLSearchParams(searchString).get('code');
  const { origin } = window.location;

  useEffect(() => {
    getAccessToken(code, undefined, origin).then(() => {
      history.push(PAGE_URLS.DASHBOARD);
    });
  }, []);

  return (
    <div className={styles.LoginAuthorized}>
      <Spin tip="Giriş Yapılıyor..." size="large" />
    </div>
  );
};

export default LoginAuthorized;
